var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"inspire"}},[(
      _vm.$store.state.userAuthentified.roleCode ==
      'RoleUtiGareCompagnieTransport'
    )?_c('v-container',{attrs:{"fluid":""}},[_c('DashboardSeller')],1):(
      _vm.$store.state.userAuthentified.roleCode == 'RoleAdminCompagnieTransport'
    )?_c('v-container',{attrs:{"fluid":""}},[_c('DashboardTransportAdmin')],1):(_vm.$store.state.userAuthentified.roleCode == 'RoleAgentGare')?_c('v-container',{attrs:{"fluid":""}},[_c('DashboardResponsableAgent')],1):(_vm.$store.state.userAuthentified.roleCode == 'RoleUtiBagagiste')?_c('v-container',{attrs:{"fluid":""}},[_c('DashboardBagagiste')],1):_c('v-container',{attrs:{"fluid":""}},[_c('DashboardMainAdmin')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }